"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var BAR_HEADER_STYLE = "flex flex-col mx-1 my-auto";
var PRIMARY_HEADER_STYLE = "font-bold text-lochivar-default text-sm";
var SECONDARY_HEADER_STYLE = "font-body text-rose-darkest text-xs -mt-1";
var BarHeader = function (_a) {
    var primary = _a.primary, secondary = _a.secondary, className = _a.className;
    return ((0, jsx_runtime_1.jsxs)("header", __assign({ className: (0, clsx_1.default)(BAR_HEADER_STYLE, className) }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ className: PRIMARY_HEADER_STYLE }, { children: primary }), void 0), (0, jsx_runtime_1.jsx)("h2", __assign({ className: SECONDARY_HEADER_STYLE }, { children: secondary }), void 0)] }), void 0));
};
exports.BarHeader = BarHeader;
